import type { AxiosResponse } from 'axios';
import axios from 'axios';

import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import {
  mapToCreateAppStateRequest,
  mapToAppStateSettings,
  mapFromApiBaseResponse,
} from './mapper';
import type { Targeting, AppStateSettings, ScopedKeyValue } from './types';

function generateUrl(userId: number) {
  return `/api/v1/users/${userId}/app-state`;
}

/**
 * Preserve app-state settings in the DB.
 *
 * @param userId User id of current user
 * @param namespace Namespace for the given setting
 * @param key The setting name we want to save
 * @param value The setting value we want to save
 * @param targeting Can include any combination of account, site & organization
 */
export function set(
  userId: number,
  scopedKeyValue: ScopedKeyValue,
  targeting?: Targeting,
): Promise<ApiBaseResponse> {
  return axios
    .post<ApiBaseResponse>(
      generateUrl(userId),
      mapToCreateAppStateRequest(scopedKeyValue, targeting),
    )
    .then((res: AxiosResponse) => res.data);
}

/**
 * Get app state settings for the current user from the DB.
 *
 * @param userId User id of current user
 * @param targeting Can include a site to filter the settings by ...
 * */
export function get(userId: number, targeting?: Targeting): Promise<AppStateSettings> {
  return axios
    .get<ApiBaseResponse>(generateUrl(userId))
    .then((res: AxiosResponse) => res.data)
    .then(mapFromApiBaseResponse)
    .then(mapToAppStateSettings(targeting))
    .catch(() => ({}));
}
